export interface IFeedback {
  Subject: string;
  Description: string;
  Images?: string[];
  // FeedbackType: EFeedbackType;
  Priority: EFeedbackPriorityType;
  UserInfo: IFeedbackUserInfo;
}

export enum EFeedbackType {
  Bug = 1,
  Feedback = 2,
  Feature = 3
}

export enum EFeedbackPriorityType {
  Lowest = 1,
  Low = 2,
  Medium = 3,
  High = 4,
  Highest = 5
}

export interface IFeedbackUserInfo {
  userId: string;
  userName: string;
  userEmail: string;
  workspaceId: string;
  workspaceName: string;
  projectId: string;
  projectName: string;
  screenId: string;
  screenName: string;
}
